<div *ngIf="data === 'Niet geactiveerd' || data === 'Geen licentie gevonden'" [class]="'kruis'"></div>
<span [class]="data">
  {{data !== null ? data : 'Niet geactiveerd' }}
</span>
